import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, Link, SegmentedControl, Select, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import GoogleMapsPoligon from '../../../../../components/maps/GoogleMapsPoligon';
import { buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';
import { ItemEquipment } from '../../../../../resources/types';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { format } from 'date-fns';

export const MembersEquipmentsSimulatePage = () => {
    const { idUser, data, menu } = useGlobalState();
    useGlobalState();
    const [selectedEquipmentType, setSelectedEquipmentType] = React.useState('');
    const [idEquipment, setIdEquipment] = React.useState(0);
    const [hours, setHours] = React.useState(0);
    const [altitude, setAltitude] = React.useState(0);
    const [totalCost, setTotalCost] = React.useState(0);
    const [totalTow, setTotalTow] = React.useState(0);
    const [equipment, setEquipment] = React.useState<ItemEquipment>();

    useEffect(() => {
        if (!equipment) return;
        const tow = parseFloat(
            equipment?.jsonAltitudes?.find((alt) => alt.altitude === altitude)?.cost
        ) || 0;
        console.log(tow)
        let realHours = hours;
        if (equipment.hourCostFree > 0) {
            if (hours > equipment.hourCostFree / 60)
                realHours = equipment.hourCostFree / 60;
        }
        const cost = equipment?.hourCost * (realHours)
        setTotalTow((tow * data.UF) || 0);
        setTotalCost((cost * data.UF) || 0);
    }, [altitude, hours, equipment]);
    const equipments = data.equipments.filter((equipment: ItemEquipment) => equipment.groupTypeMasterCode === "GLIDER" || equipment.groupTypeMasterCode === "PLANE").filter((equipment: ItemEquipment) => equipment.jsonOwners.includes(idUser) || equipment.isClub === 1);


    const handleGetEquipment = async (idEquipment: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idEquipment: idEquipment,
                    notes: true,
                    docs: true,
                    image: true,
                    bookings: true,
                    flights: true,

                })
            });
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.equipment) {
                setEquipment(data.equipment);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />} description="Calculadora de costos de hora de vuelo">Simulador</Header>
                    <SegmentedControl options={[
                        { text: 'Planeador', id: 'GLIDER' },
                        { text: 'Avión', id: 'PLANE' },
                    ]} selectedId={selectedEquipmentType} onChange={({ detail }) => {

                        setSelectedEquipmentType(detail.selectedId);
                    }} />
                    {selectedEquipmentType !== "" && (
                        <div style={{ width: 200 }}>
                            <FormField label="Material">
                                <Select
                                    options={equipments.filter((equipment: ItemEquipment) => equipment.groupTypeMasterCode === selectedEquipmentType).map((equipment: ItemEquipment) => ({
                                        value: equipment.idEquipment.toString(), label: equipment.registration,
                                        description: equipment.make + " - " + equipment.model
                                    }))}
                                    selectedOption={equipments.filter((equipment: ItemEquipment) => equipment.idEquipment === idEquipment).map((equipment: ItemEquipment) => ({
                                        value: equipment.idEquipment.toString(), label: equipment.registration,
                                        description: equipment.make + " - " + equipment.model
                                    }))[0]}
                                    placeholder="Seleccione un material"
                                    onChange={(detail) => {
                                        setEquipment(undefined);
                                        handleGetEquipment(Number(detail.detail.selectedOption.value)),
                                            setIdEquipment(Number(detail.detail.selectedOption.value))
                                    }}
                                />
                            </FormField>
                        </div>

                    )}

                    {!!equipment && (

                        <SpaceBetween size="s" direction='vertical'>
                            <SpaceBetween size="s" direction='horizontal'>
                                <FormField label="Tiempo de vuelo">
                                    <Select
                                        options={[...Array(10).keys()].map((i) => ({
                                            value: (i + 1).toString(),
                                            label: `${i + 1} hora${i + 1 > 1 ? 's' : ''}`,
                                        }))}
                                        selectedOption={{ value: hours.toString(), label: `${hours} hora${hours > 1 ? 's' : ''}` }}
                                        onChange={(detail) => {
                                            setHours(Number(detail.detail.selectedOption.value))
                                        }}
                                    />
                                </FormField>
                                {equipment.jsonAltitudes.length > 0 && (
                                    <FormField label="Altura de remolque">

                                        <Select
                                            options={[
                                                { value: "0", label: "Sin remolque" },
                                                ...equipment.jsonAltitudes.map((altitude: any) => ({
                                                    value: altitude.altitude,
                                                    label: `${altitude.altitude} metros`,
                                                }))
                                            ]}
                                            selectedOption={
                                                { value: altitude.toString(), label: altitude === 0 ? "Sin remolque" : `${altitude} metros` }
                                            }
                                            onChange={(detail) => {
                                                setAltitude(Number(detail.detail.selectedOption.value))
                                            }}
                                        />
                                    </FormField>
                                )}
                            </SpaceBetween>
                            {totalCost > 0 && (
                                <SpaceBetween size="s" direction='vertical'>
                                    <SpaceBetween size="s" direction='horizontal'>
                                        <FormField label="Total vuelo">
                                            <Header variant="h1">{formatCurrency(totalCost, "CLP")}</Header>
                                        </FormField>

                                        <FormField label="Total remolque">
                                            <Header variant="h1">
                                                {totalTow === 0 ? "---------" : formatCurrency(totalTow, "CLP")}</Header>
                                        </FormField>
                                        <FormField label="Costo final">
                                            <Header variant="h1">{formatCurrency(totalTow + totalCost, "CLP")}</Header>
                                        </FormField>
                                    </SpaceBetween>
                                    <small>* Valores referenciales al momento de la consulta ({format(new Date, "dd-MM-yyyy HH:mm")})</small>
                                </SpaceBetween>
                            )}
                        </SpaceBetween>
                    )}

                </SpaceBetween>
            }
        />
    )
};
